import { defineComponent as M, ref as f, computed as p, toRef as U, toValue as R, isRef as x, watch as m, toRaw as z, createElementBlock as G, openBlock as H, mergeProps as J, renderSlot as K, unref as V, onMounted as L, onUnmounted as Q } from "vue";
import T from "core-js-pure/actual/structured-clone";
import { isEmpty as b } from "../../utils/isEmpty.js";
import { isEqual as h } from "../../utils/isEqual.js";
import { subscribe as W, unsubscribe as X } from "./Form.actions.js";
import { makeValidate as Y, getRequiredFieldsFromValidate as Z, mergeFormValues as w } from "./Form.helpers.js";
import { useValidation as N } from "./composables/useValidation.js";
const oe = /* @__PURE__ */ M({
  name: "RevForm",
  inheritAttrs: !1,
  __name: "Form",
  props: {
    name: { default: void 0 },
    initialValues: {},
    validate: { default: () => Y() }
  },
  emits: ["init", "visible-errors-change", "on-submit-failed", "submit"],
  setup(C, { emit: O }) {
    const i = C, o = O;
    function j(e) {
      function a(s) {
        const l = e[s.type];
        l && l(s.payload);
      }
      L(() => {
        i.name && W(i.name, a);
      }), Q(() => {
        i.name && X(i.name, a);
      });
    }
    const r = f(), q = p(() => r.value ? Object.values(r.value).some(Boolean) : !1), y = (e) => {
      if (!e) {
        r.value = {};
        return;
      }
      r.value = Object.fromEntries(
        Object.keys(e).map((a) => [a, !1])
      );
    }, t = f({}), u = f(), _ = p(() => h(t.value, i.initialValues)), F = U(
      () => x(i.validate) ? R(i.validate) : i.validate
    ), {
      validateAllFields: d,
      validateOnlyDirtyAndInErrorFields: B,
      visibleErrors: E,
      hasVisibleError: S,
      makeErrorsVisible: v,
      isValid: n,
      resetValidation: g,
      errors: c
    } = N(
      t,
      r,
      F
    ), P = p(() => {
      const e = R(F);
      return Z(e);
    });
    function k(e, a = t.value) {
      t.value = { ...w(a, e) }, u.value = { ...t.value }, d();
    }
    function D(e = {}) {
      y(t.value), k(e);
    }
    m(
      () => i.initialValues,
      (e, a) => {
        g();
        const s = z(e), l = T(s);
        D(l), a || o("init", { isValid: n.value, values: l });
      },
      { immediate: !0 }
    ), m(
      () => ({ ...E.value }),
      (e, a) => {
        !b(e) && !h(e, a) && o("visible-errors-change", { errors: e });
      },
      { immediate: !0 }
    ), m(
      t,
      (e) => {
        e && (Object.keys(e).forEach((a) => {
          if (!r.value)
            return;
          const s = !b(u.value) && !h(u.value?.[a], e[a]), l = r.value[a] === !0, $ = s || l;
          r.value[a] = $;
        }), u.value = { ...e }, B());
      },
      { deep: !0 }
    ), m(
      () => i.validate,
      async () => {
        d(), v();
      },
      {
        deep: !0,
        // Do not show the validation errors on the first render.
        // Note that `immediate: false` is the default value
        // but we keep it here for clarity.
        immediate: !1
      }
    );
    function A(e) {
      e && e.preventDefault(), d(), v(), y(t.value), n.value ? o("submit", t.value) : o("on-submit-failed", { errors: c.value });
    }
    function I() {
      return g(), D(i.initialValues), { isValid: n.value, values: t.value };
    }
    return j({
      submit: () => A(),
      reset: I,
      setValues: (e) => k(e),
      setErrors: function(a) {
        b(a) || (c.value = { ...c.value, ...a }, v());
      }
    }), (e, a) => (H(), G("form", J(e.$attrs, { onSubmit: A }), [
      K(e.$slots, "default", {
        dirtyFields: r.value,
        errors: V(E),
        hasError: V(S),
        hasInitialValues: _.value,
        isDirty: q.value,
        isValid: V(n),
        requiredFields: P.value,
        reset: I,
        values: t.value
      })
    ], 16));
  }
});
export {
  oe as default
};
